import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@components/atoms/button';
import type { QrCodeProps } from '@components/moleculs/qr-code/types';
import { QRCodeCanvas } from 'qrcode.react';
import { styled } from 'styled-components';

import { QrCodeContainer } from './styles';

const Molecule: React.FC<QrCodeProps> = ({ value, size, className, isDownloadable, name }) => {
    const { t } = useTranslation();
    const ref = useRef<HTMLDivElement | null>(null);

    const handleDownloadClick = () => {
        if (ref.current) {
            const canvas = ref.current?.querySelector('canvas');

            if (canvas) {
                const data = canvas.toDataURL();
                const link = document.createElement('a');

                link.download = `${name}.png`;
                link.href = data;
                link.click();
            }
        }
    };

    return (
        <QrCodeContainer className={className} ref={ref}>
            <QRCodeCanvas value={value} size={size} />
            {isDownloadable && (
                <Button
                    variant='ghost'
                    onClick={handleDownloadClick}
                    className='download-qr-button'
                >
                    {t('common.download')}
                </Button>
            )}
        </QrCodeContainer>
    );
};

export const QrCode = styled(Molecule)({});
